/** 极简 className 合并：过滤假值并去重空白。不引入 clsx。 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ').replace(/\s+/g, ' ').trim()
}
